@if (usage$ | async; as usage) {
  <div class="mt-2">
    @switch (usage.status) {
      @case (WarehouseGoodUsageStatus.NeverUsage) {
        <div class="text-sm text-green-500">
          <span>Brak powiązania towaru z obiektami w sklepie.</span>
        </div>
      }
      @case (WarehouseGoodUsageStatus.ConnectedWithOtherObjects) {
        <div class="text-sm text-orange-500">
          <span> Istnieją powiązania towaru z obiektami w sklepie: </span>

          @for (
            object of usage.connectedObjects;
            track object;
            let isLast = $last
          ) {
            @if (
              object.id === currentObjectId() &&
              object.type === currentObjectType()
            ) {
              <span pTooltip="Aktualnie otwarty obiekt">
                <strong>{{ object.name }}</strong>
              </span>
            } @else {
              <span>{{ object.name }}</span>
            }

            @if (!isLast) {
              <span>, </span>
            }
          }
          <span>.</span>
        </div>
      }
    }
  </div>
}
